const ANONYMOUS_ID_KEY = 'gleam_analytics_anonymous_id'
const SESSION_ID_KEY = 'gleam_analytics_session_id'

export function getAnalyticsAnonymousId(): string | null {
  return getOrCreateStoredId('local', ANONYMOUS_ID_KEY)
}

export function getAnalyticsSessionId(): string | null {
  return getOrCreateStoredId('session', SESSION_ID_KEY)
}

function getOrCreateStoredId(storageType: 'local' | 'session', key: string): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  const storage = storageType === 'local' ? window.localStorage : window.sessionStorage

  try {
    const existing = storage.getItem(key)
    if (existing) {
      return existing
    }

    const next = createId()
    storage.setItem(key, next)
    return next
  } catch {
    return null
  }
}

function createId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}
